import {schemaRequest} from '../../actions/schemaActions';
const dispatchSchemaRequest = (component) => {
  component.props.dispatch(schemaRequest(component.props.id));
};

export default dispatchSchemaRequest;